<script src="../../../app-routing.module.ts"></script>
<!-- {{ knowledgeBaseService.selectedProductionLine() | json }} <br />
{{ knowledgeBaseService.selectedWorkplace() | json }} <br />
{{ knowledgeBaseService.selectedCategory() | json }} <br /> -->
<!--<pre>
   {{ knowledgeBaseService.expandedNodes() | json }}
  {{ knowledgeBaseService.treeDataSource() | json }}
  {{ knowledgeBaseService.expandedNodeIdsSignal() | json }}
 </pre>-->
<app-search-filter-bar
  [useFilter]="false"
  [useBackNavigation]="knowledgeBaseService.activePage() == 0 || knowledgeBaseService.activePage() == 3"
  (navigateBack)="back()"
  (valueChange)="onValueChange($event)"
  (startSearch)="triggerSearch()"
></app-search-filter-bar>
<div class="container-fluid p-4">
  <div class="row justify-content-evenly">
    <div
      class="col-12 mb-3 active-view"
      *ngIf="knowledgeBaseService.activePage() == 0"
    >
      <app-kd-workplace-selection></app-kd-workplace-selection>
    </div>
    <div class="col-12 mb-3" *ngIf="knowledgeBaseService.activePage() == 1">
      <app-kd-workplace></app-kd-workplace>
    </div>
    <div
      class="col-12 active-view"
      *ngIf="knowledgeBaseService.activePage() == 2"
    >
      <app-kd-solution></app-kd-solution>
    </div>
    <div
      class="col-12 active-view"
      *ngIf="knowledgeBaseService.activePage() == 3"
    >
      <app-kd-search-results></app-kd-search-results>
    </div>

  </div>
</div>
